export default "__VITE_ASSET__D3al16cR__"